import { Component, lazy, Suspense } from "react";
import PaperBlocks from "@/components/PaperBlocks";

// আসল অ্যাপের ExamPaperPreview (ভারী: katex, gesture...) — শুধু paper পেজে লাগে, তাই lazy
const PaperPreview = lazy(() => import("@/live/PaperPreview"));

class Boundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(err) {
    console.error("Paper preview failed, showing simplified view:", err);
  }
  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}

export default function PaperViewer({ paper }) {
  // JSON অসম্পূর্ণ/অচেনা হলে পেজ ভাঙার বদলে সরল (sanitized) ভিউ
  const fallback = (
    <div className="paper-card p-6 sm:p-8">
      <PaperBlocks blocks={paper?.blocks ?? []} />
    </div>
  );
  return (
    <div className="gallery-paper-viewer">
      <Boundary fallback={fallback}>
        <Suspense fallback={<div className="h-96 w-full animate-pulse rounded-xl bg-muted" aria-busy="true" />}>
          <PaperPreview paper={paper} />
        </Suspense>
      </Boundary>
    </div>
  );
}
